import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'error_dialog',
  standalone: true,
  templateUrl: './error_dialog.component.html',
  styleUrls: ['./error_dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule
  ]
})
export class ErrorDialogComponent {
  title: string;
  content: string;
  buttons: any[];

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _dialogRef: MatDialogRef<ErrorDialogComponent>,
  ) {
    this.title = data.title;
    this.content = data.content;
    this.buttons = this.mapButtons(data.buttons);
    this._dialogRef.addPanelClass('error-dialog-panel');
  }

  /**
   * On init
   */
  ngOnInit(): void {}

  mapButtons(buttonsConfig: any[]) {
    return buttonsConfig.map(button => {
      return {
        label: button.label,
        action: this.getAction(button.action),
        class: this.getButtonClass(button.action)
      };
    });
  }

  getAction(action: string) {
    const actions: any = {
      'yes': this.yesClick.bind(this),
      'ok': this.close.bind(this)
    };

    return actions[action];
  }

  getButtonClass(action: string) {
    const buttonClass: any = {
      'yes': 'bg-red-600 text-white border-none',
      'ok': 'btn-cancel border-neutral-200'
    };

    return buttonClass[action];
  }

  yesClick() {
    this._dialogRef.close({return: 'success'});
  }

  close(): void {
    this._dialogRef.close({return: ''});
  }
}
